<script lang="ts">
import {getIdentifier} from "@/services/ItemFunction"
import {helper} from "@/services/Helper"

// Composant fonctionnel : peut retourner un array de VNodes (tr siblings)
// Pas de tbody wrapper → pas de tbody imbriqué → colonnes correctement alignées
const RecapItemRow: any = {
  name: 'RecapItemRow',
  functional: true,
  props: {
    uuid: {type: String, required: true},
    level: {type: Number, default: 0},
  },
  render(h: any, ctx: any) {
    const store = ctx.parent.$store
    const items = store.state.contractStore.items
    const itemTypes = store.state.contractStore.itemTypes
    const item = items[ctx.props.uuid]
    if (!item || item.modelCode === 'coverage') return []
    const model = itemTypes[item.modelCode]
    if (!model) return []

    const covUuids = item.properties?.couverture
    const covUuid = Array.isArray(covUuids) ? covUuids[0] : covUuids
    const cov = covUuid ? items[covUuid] : null

    // Opération : label de la choice depuis le modèle
    const opCode = item.properties?.operation
    let opLabel = ''
    if (opCode) {
      const props = Array.isArray(model.properties) ? model.properties : Object.values(model.properties || {})
      const opProp: any = props.find((p: any) => p.code === 'operation')
      const choice: any = (opProp?.choices || []).find((c: any) => c.code === opCode)
      opLabel = choice?.label || opCode
    }

    const nodes: any[] = []
    nodes.push(h('tr', {key: 'rir_' + ctx.props.uuid}, [
      h('td', {style: 'padding:8px 10px;font-weight:600'}, ''),
      h('td', {style: 'padding:8px 10px;padding-left:' + (10 + ctx.props.level * 24) + 'px;font-weight:600'},
        getIdentifier(item) || item.name),
      h('td', {style: 'padding:8px 10px'}, model.name || item.modelCode),
      h('td', {style: 'padding:8px 10px;text-transform:uppercase'}, opLabel || '-'),
      h('td', {style: 'padding:8px 10px;text-transform:uppercase'}, cov ? cov.properties?.label : '-'),
      h('td', {style: 'padding:8px 10px;text-align:right;font-weight:600'},
        cov && cov.properties?.premium ? helper.currencyFormat(cov.properties.premium) : '-'),
    ]))

    const props = Array.isArray(model.properties) ? model.properties : Object.values(model.properties || {})
    for (const pm of props as any[]) {
      const fmt = pm.type?.format || pm.type?.code || ''
      if (!fmt.match(/OBJECT/)) continue
      if (pm.code === 'couverture') continue
      const val = item.properties?.[pm.code]
      const children = Array.isArray(val) ? val : (val ? [val] : [])
      for (const childUuid of children) {
        const child = items[childUuid]
        if (!child || child.modelCode === 'coverage') continue
        nodes.push(h(RecapItemRow, {
          props: {uuid: childUuid, level: ctx.props.level + 1},
          key: 'rir_' + childUuid,
        }))
      }
    }
    return nodes
  },
}
export default RecapItemRow
</script>
